import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { getDocumentsIds, selectDocumentsIds } from '@/features/admin/documentsIds';
import { selectAuthUser } from '@/features/auth';

export interface DocumentsProviderProps {
  children?: React.ReactNode;
}

export const DocumentsProvider: React.FC<DocumentsProviderProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const documentsIds = useAppSelector(selectDocumentsIds);
  const user = useAppSelector(selectAuthUser);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (user && !documentsIds && !isInitialized) {
      setIsInitialized(true);
      dispatch(getDocumentsIds())
        .unwrap()
        .catch((error) => {
          console.error('Failed to fetch document IDs:', error);
          setIsInitialized(false);
        });
    }

    if (!user && isInitialized) {
      setIsInitialized(false);
    }
  }, [dispatch, documentsIds, user, isInitialized]);

  return <>{children}</>;
};
